module.exports = __webpack_public_path__ + "static/p4ktldr-wilco-zoom-e03f680d43f03dce74c9c533af762b3d.jpg";